module.exports = __webpack_public_path__ + "static/media/project.673c346d.svg";